@if (isAdmin$ | async) {
  <button mat-icon-button class="edit-button" (click)="toggleEdit()">
    @if (!editing) {
      <mat-icon title="Edit top node name">edit</mat-icon>
    }
    @if (editing) {
      <mat-icon title="Done editing">check</mat-icon>
    }
  </button>
}
@if (editing) {
  <button mat-icon-button (click)="cancelEdit()">
    <mat-icon title="Cancel editing">close</mat-icon>
  </button>
}
<!--suppress HtmlFormInputWithoutLabel -->
@if (editing) {
  <input #input [formControl]="editText" type="text">
}
@for (pathElement of path; track pathElement; let i = $index) {
  @if (!shouldHide(pathElement)) {
    <a mat-button [routerLink]="getRouterLink(pathElement) | async">
      <div class="breadcrumb">{{ pathElement.label || '&nbsp;' }}</div></a>
    }
  }

  @for (pathElement of localPath$ | async; track pathElement) {
    @if (!!pathElement) {
      <a mat-button class="breadcrumb" [routerLink]="getRouterLink(pathElement) | async">
        <div class="breadcrumb local">{{ pathElement.label || '&nbsp;' }}</div></a>
      }
    }
